// Values are always in snake_case
// Naming convention is coming from PostHog's best practices: https://posthog.com/docs/product-analytics/best-practices

export const EVENT_CATEGORIES = {
  ACCOUNT_SELECTION: 'account_selection',
  ADDRESSES: 'addresses',
  AUTH: 'auth',
  BILLING: 'billing',
  INSTALMENT_CHECK: 'instalment_check',
  CANCEL_SUPPLIER_SWITCH: 'cancel_supplier_switch',
  COMPLAINT: 'complaint',
  CONSUMPTION: 'consumption',
  CONTACT: 'contact',
  CONTRACT: 'contract',
  ENERGY_OVERVIEW: 'energy_overview',
  FEEDBACK: 'feedback',
  GUARANTEE_OF_ORIGIN: 'guarantee_of_origin',
  MARKET_PRICES: 'market_prices',
  METER_READINGS: 'meter_readings',
  MOVE: 'move',
  OVERVIEW: 'overview',
  PRODUCER: 'producer',
  REFERRAL: 'referral',
  SUPPORT: 'support',
  USER: 'user',
  PRODUCT_SWITCH: 'product_switch'
} as const

export const EVENT_ACTIONS = {
  ADD: 'add',
  CANCEL: 'cancel',
  CLICK: 'click',
  CONFIRM: 'confirm',
  CREATE: 'create',
  DELETE: 'delete',
  END: 'end',
  FAIL: 'fail',
  FINISH: 'finish',
  GENERATE: 'generate',
  HIDE: 'hide',
  INVITE: 'invite',
  REMOVE: 'remove',
  SEND: 'send',
  START: 'start',
  SUBMIT: 'submit',
  UPDATE: 'update',
  VIEW: 'view'
} as const

export const TRACKING_PARAMS = {
  customerType: 'customer_type',
  duration: 'duration_ms',
  currentLanguage: 'current_language'
} as const

export const FEATURE_FLAGS = {}
